import { render } from "./LogoutSvg.vue?vue&type=template&id=4588a9fd&bindings={}"
import script from "./LogoutSvg.vue?vue&type=script&lang=ts"
export * from "./LogoutSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script